export default __webpack_public_path__ + "static/media/6.0031ef87.jpg";